import {useEffect, useState} from "react";
import {SideEffectList} from "./SideEffectList";
import {DrugPDBList} from "./DrugPDBList";
import {Col, Row} from "antd";
import {SearchResultList} from "./SearchResultList";
import {SearchResultsHeader} from "./SearchResultsHeader";
import {useParams} from "react-router-dom";
import {getDrugPDBSearch} from "../Utils/api";

export const DrugPDBDetails = () => {
  const params = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [listSwitcher, setListSwitcher] = useState("drug-disease")
  const [data, setData] = useState({
    data: {
      drugPDB: [],
      sideEffects: [],
    },
    count: {
      drugPDB: 0,
      sideEffects: 0
    }
  })

  const switchValue = listSwitcher => {
    if (listSwitcher === 'sideEffects') {
      return(
        <SideEffectList data={data.data.sideEffects} isLoading={isLoading} />
      )
    } else {
      return(
        <DrugPDBList data={data.data.drugPDB} isLoading={isLoading} />
      )
    }
  }

  useEffect(() => {
    setIsLoading(true)
    getDrugPDBSearch({
      term: params.item
    }).then(r => setData(r.data))
      .then(_ => setIsLoading(false))
  }, [params.item])

  return(
    <Row gutter={[20, 20]}>
      <Col lg={6} xs={24}>
        <SearchResultList count={data.count} data={data.data} isLoading={isLoading} setListSwitcher={setListSwitcher} />
      </Col>
      <Col lg={18} xs={24}>
        <SearchResultsHeader title={params.item} />
        <br />
        {switchValue(listSwitcher)}
      </Col>
    </Row>
  )
}